/**
 * Same rule as Dashboard: usable organisation settings require a business `name`.
 */
export function hasOrganisationSettings(organisationList) {
  if (!Array.isArray(organisationList) || organisationList.length === 0) return false;

  const organisation = organisationList.find((item) => item?.isDefault) || organisationList[0];
  return Boolean(organisation && typeof organisation === 'object' && 'name' in organisation);
}

/**
 * After auth succeeds, resolve where to land.
 * Brokers → admin subscriptions.
 * Users without organisation settings → organisation settings.
 * Everyone else → dashboard.
 */
export default async function resolvePostLoginPath({
  fetchBroker,
  fetchOrganisations,
  organisationList,
} = {}) {
  if (typeof fetchBroker === 'function') {
    try {
      const response = await fetchBroker();
      const broker = response?.data;
      if (broker && (broker.brokerageId || broker.brokerId)) {
        return '/admin/brokerage-subscriptions';
      }
    } catch {
      // Non-broker accounts (or failed broker lookup) fall through.
    }
  }

  let organisations = organisationList;
  if (organisations == null && typeof fetchOrganisations === 'function') {
    try {
      const response = await fetchOrganisations();
      organisations = response?.data;
    } catch {
      return '/organization';
    }
  }

  if (!hasOrganisationSettings(organisations)) {
    return '/organization';
  }

  return '/dashboard';
}
